































import { InterventionApi } from "../../api/InterventionApi";
import DashboardTable from "../../core/Tables/DashboardTable.vue";
import { Intervention } from "../../models/Intervention";
import moment from "moment";

export default {
    name: "FacturationsEnRetard",
    components: { DashboardTable },
    data() {
        return {
            facturations: [],
            InterventionApi: new InterventionApi(),
        };
    },
    created() {
        let self = this;
        self.InterventionApi.getAlerts(
            Intervention.EAlertType.LateFacturations
        ).then(function (res) {
            self.facturations = res;
        });
    },
    methods: {
        humanReadableDate(date: string): string {
            return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
        },
    },
};
